import Vue from 'vue'
import { BaseModel } from '..'

class Banners extends BaseModel {
    constructor(json, ...args) {
        super(...args)
        this.apiRoot = 'frontend-api'
        this.apiVersion = 'public'
        this.apiBase = 'banners'
    }

    async fetch(id) {
        this._loading = true
        const url = id ? `${this.base}/${id}` : this.base
        const params = id
            ? {}
            : {
                  residentialCanteenId: Vue.prototype.$cart.residentialcanteen_id,
                  cloudCanteenId: Vue.prototype.$cart.cloudcanteen_id,
              }
        return await this._client.index(url, params)
    }
}

export { Banners }
